module.exports = __webpack_public_path__ + "img/COVID-19-ອາຊຽນ.psd4-Recovered-1-711x800.0802a6d2.jpg";